import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AssignPhoneNumberSettings from './assign-phone-number-settings';
import { getUsersListRequest, assignPhoneNumberRequest, getPhoneNumberDetailsRequest } from '../../../../../../../../extra-actions';
import { RootState } from '../../../../../../../../../../store/root-reducer';
import toaster, { Theme } from '../../../../../../../../../../shared/toaster';
import { executeOnRequestStatus } from '../../../../../../../../../../shared/utils';
import { resetAssignPhoneNumberRequest } from '../../../../../../../../dialer-slice';

const AssignPhoneNumberSettingsContainer: React.FC = () => {
  const dispatch = useDispatch();
  const activeNumberSettings = useSelector(
    (state: RootState) => state.dialer.activeNumberSettings,
  );
  const teamMembersList = useSelector(
    (state: RootState) => state?.dialer?.teamMembersList || [],
  );
  const assignPhoneNumberRequestStatus = useSelector(
    (state: RootState) => state.dialer.assignPhoneNumberRequest.status,
  );

  const getTeamMembersListRequest = useCallback(() => {
    dispatch(getUsersListRequest());
  }, [dispatch]);

  const handleSave = useCallback(
    (phoneNumberId: number, userId: number) => {
      dispatch(
        assignPhoneNumberRequest({
          phoneNumberIds: [phoneNumberId],
          userId,
        }),
      );
    },
    [dispatch],
  );

  // Show success toaster when assignment succeeds
  useEffect(() => {
    executeOnRequestStatus({
      status: assignPhoneNumberRequestStatus,
      onSuccess: () => {
        toaster.success('Number Setting Updated Successfully', { theme: Theme.New });
        dispatch(getPhoneNumberDetailsRequest(activeNumberSettings?.id as number));
        dispatch(resetAssignPhoneNumberRequest());
      },
      onFailed: () => {
        dispatch(resetAssignPhoneNumberRequest());
      },
    });
  }, [assignPhoneNumberRequestStatus]);

  return (
    <AssignPhoneNumberSettings
      activeNumberSettings={activeNumberSettings}
      teamMembersList={teamMembersList}
      getTeamMembersListRequest={getTeamMembersListRequest}
      assignPhoneNumberRequestStatus={assignPhoneNumberRequestStatus}
      onSave={handleSave}
    />
  );
};

export default memo(AssignPhoneNumberSettingsContainer);

